import React, { Component } from 'react'

class SliderBasicDescription extends Component {
    render() {
        const { description } = this.props

        if(!description) {
            return ''
        }

        return <p className={'description text-xlarge-medium'} style={{whiteSpace: "pre-line"}} dangerouslySetInnerHTML={{ __html: description}}></p>
    }

}  

export default SliderBasicDescription